<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '420px' }"
    header="Fomulário de Tipo"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <label for="desc">Descrição do Tipo</label>
        <InputText
          id="des"
          v-model="v$.tipo.descricao.$model"
          maxlength="100"
          placeholder="Digite o tipo"
          :class="{ 'p-invalid': submitted && v$.tipo.descricao.$invalid }"
        />
        <small v-if="submitted && v$.tipo.descricao.$invalid" class="p-error"
          >Descrição é obrigatório.</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.tipo.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Tipo from "../../../models/tipo";

//Services
import TipoService from "../../../service/tipo/tipoService";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      tipo: new Tipo(),
      tipoService: new TipoService(),
      submitted: false,
    };
  },
  validations() {
    return {
      tipo: new Tipo().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.tipo.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.tipo.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.tipo.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.tipoService
        .create(this.tipo)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.tipoService
        .update(this.tipo)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.tipo = new Tipo();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.tipo = this.selected;
    },
  },
};
</script>
<style scoped></style>
